export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail or username',
      invalidEmailOrUsername: 'Invalid e-mail or username',
      invalidCredentials: 'Invalid credentials',
      invalidPassword: 'Invalid password',
      logInToGo360: 'Log in to Shakkii',
      signUpToGo360: 'Create your Shakkii account',
      needAnAccount: 'Create your account',
      alreadyHaveAccount: 'Back to sign in',
      noInternetConnection: 'No internet connection',
      pageNotFound_title: 'Page Not Found',
      password: 'Password',
      projectManagement: 'AI Assistant',
      serverConnectionFailed: 'Server connection failed',
      unknownError: 'Unknown error, try again later',
      useSingleSignOn: 'Use single sign-on',
    },

    action: {
      logIn: 'Log in',
      logInWithSSO: 'Log in with SSO',
    },
  },
};
